import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import axios from 'axios';

import Moment from 'moment';
import 'moment/locale/pt-br';

import { Icons } from "../helpers/Icons";

const Comunicado = ( props ) => {

    const [ state, setState ] = useState({
        comunicado: [],
        isLoaded: false,
        actualID: false
    })

    const getData = ( comunicadoId ) => {

        const url = `${process.env.REACT_APP_SERVER_URL}wp-json/wp/v2/comunicados?slug=${comunicadoId}&siteID=${window.siteID}_fields=id,slug,title,date'`;
        axios
            .get( url )
            .then(res => setState({
                comunicado: res.data.shift(),
                isLoaded: true,
                actualID: comunicadoId
            }))
            .catch(
                err => console.log(err)
            )
        ;
        
    }

    useEffect(() => {
        getData( props.comunicadoID );
    }, [ props.comunicadoID ] )
    
    const { comunicado, isLoaded } = state;
    if( !isLoaded || !comunicado ) return null;

    var _title = comunicado.title.rendered + ' | Comunicados';
    var _description = comunicado.content.rendered.replace( /<[^>]+>/g, '' );

    return(
    <article className="comunicado">
        <Helmet>
            <title>{_title}</title>
            <meta property="og:title" content={_title} />
            <meta property="og:description" content={_description} />
            <meta name="twitter:title" content={_title} />
            <meta name="twitter:description" content={_description} />
        </Helmet>
        { props.isMobile &&
        <NavLink to="/comunicados">Fechar</NavLink>}
        <h2>{comunicado.title.rendered}</h2>
        <em>
            <Icons tag="calendar" />
            {Moment(comunicado.date).format('LL')}
        </em>
        <div>
            <span dangerouslySetInnerHTML={{ __html: comunicado.content.rendered }} />
        </div>
    </article>);
    
}

export default Comunicado;
